import { render, staticRenderFns } from "./Link2OffIcon.vue?vue&type=template&id=dc05fae6"
import script from "./Link2OffIcon.vue?vue&type=script&lang=js"
export * from "./Link2OffIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports